import { ArrowBack, AutoAwesome, Close, Delete } from "@mui/icons-material"
import { Divider, IconButton } from "@mui/material"
import Tooltip from "components/material/tooltip"
import PropTypes from "prop-types"
import { useAiTeammateContext, useMessagesContext, useThreadsContext } from "../../hooks/context"
import AiTeammateHeaderMetadata from "./metadata"
import "./style.scss"

export default function AiTeammateHeader({ onClose }) {
  const { setError } = useAiTeammateContext()
  const { threadId, isThreadOpen, hasThreads, setThreadIdToDelete, closeThread, refetch: refetchThreads, threadTitle } = useThreadsContext()
  const { isSendingMessage } = useMessagesContext()

  function handleCloseThread() {
    closeThread()
    setError(null)
    refetchThreads()
  }

  return <div className="ai-teammate-header">
    <div className="header-top">
      <div className="header-left">
        {isThreadOpen && hasThreads && <IconButton onClick={handleCloseThread} title="Back to threads list" disabled={isSendingMessage}>
          <ArrowBack />
        </IconButton>}
        {isThreadOpen && <Tooltip title={threadTitle} classes={{ tooltip: "large" }}><span className="title">{threadTitle || "New Chat"}</span></Tooltip>}
        {!isThreadOpen && <>
          <AutoAwesome color="primary" />
          <span className="title">AI Teammate</span>
          <div className="beta-tag">beta</div>
        </>}
      </div>
      <div className="header-right">
        {threadId && <IconButton onClick={() => setThreadIdToDelete(threadId)} title="Delete Thread">
          <Delete />
        </IconButton>}
        <IconButton onClick={onClose} title="Close AI Teammate">
          <Close />
        </IconButton>
      </div>
    </div>
    <Divider />
    <AiTeammateHeaderMetadata />
  </div>
}

AiTeammateHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
}
